import React, {Component, createRef} from "react";
import PersonalDataBlock from "./PersonalDataBlock";
import ConsumptionBlock from "./ConsumptionBlock";
import LocationBlock from "./LocationBlock";

export default class Form extends Component {
    constructor() {
        super(...arguments);

        const options = JSON.parse(this.props.options);

        this.operator_grms = options.operator_grms;
        this.building_types = options.building_types;

        this.state = {
            application: {
                last_name: "",
                first_name: "",
                middle_name: "",
                ipn: "",
                email: "",
                phone_number: "",
                region_id: "",
                district_id: "",
                city_id: "",
                street_id: "",
                street_name_manual: "",
                building_number: "",
                apartment_number: "",
                postcode: "",
                operator_grm_id: "",
                building_type: "",
                eic: "56X",
            },
            acceptTerms: false,
            success: false,
            errors: {},
        }

        this.updateApplication = this.updateApplication.bind(this);
        this.updateErrors = this.updateErrors.bind(this);
        this.submit = this.submit.bind(this);
    }

    updateApplication(attr, value) {
        this.setState(prevState => ({
            application: {
                ...prevState.application,
                [attr]: value
            }
        }))
    }

    updateErrors(attr, value) {
        this.setState(prevState => ({
            errors: {
                ...prevState.errors,
                [attr]: value
            }
        }))
    }

    submit() {
        const {application} = this.state;
        let formData = new FormData();
        _.map(application, (value, key) => {
            formData.append(key, value ? value : '')
        });

        axios.post('/gas/join', formData)
            .then((res) => {
                this.setState({
                    success: true,
                    errors: {}
                }, () => {
                    // window.scroll(0, 0);
                    sessionStorage.setItem('eic', this.state.application.eic)
                    window.location.href = '/gas/documents'
                });
            })
            .catch((error) => {
                this.setState({errors: error.response.data.errors || {}});
            })
    }

    render() {
        const {application, acceptTerms, success, errors} = this.state;

        return (
            <div>
                <h1 className="mb-5 font-weight-bolder">{window.translates.join_form.header}</h1>
                {success &&
                <div className="alert alert-success" role="alert">
                    {window.translates.join_form.success_message} <a href="/gas/documents">{window.translates.join_form.go_to_upload}</a>
                </div>
                }
                <PersonalDataBlock
                    onChange={this.updateApplication}
                    first_name={application.first_name}
                    last_name={application.last_name}
                    middle_name={application.middle_name}
                    ipn={application.ipn}
                    email={application.email}
                    phone_number={application.phone_number}
                    errors={errors}
                    updateErrors={this.updateErrors}
                />
                <ConsumptionBlock
                    onChange={this.updateApplication}
                    operator_grms={this.operator_grms}
                    building_types={this.building_types}
                    eic={application.eic}
                    operator_grm_id={application.operator_grm_id}
                    building_type={application.building_type}
                    errors={errors}
                    updateErrors={this.updateErrors}
                />
                <LocationBlock
                    onChange={this.updateApplication}
                    region_id={application.region_id}
                    district_id={application.district_id}
                    city_id={application.city_id}
                    street_id={application.street_id}
                    street_name_manual={application.street_name_manual}
                    postcode={application.postcode}
                    building_number={application.building_number}
                    apartment_number={application.apartment_number}
                    errors={errors}
                />
                <div className="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id="accept_terms"
                        value={acceptTerms}
                        onChange={(e) => this.setState({acceptTerms: e.target.checked})}
                    />
                    <label className="custom-control-label" htmlFor="accept_terms">{window.translates.join_form.accept_terms}</label>
                </div>

                <button className="btn btn-warning btn-site my-4" type="button"
                        onClick={this.submit}
                        disabled={!acceptTerms || success}
                >
                    {window.translates.join_form.continue_button}
                </button>
            </div>
        )
    }
}
